import React, { Component } from "react";
import { fire, auth } from "../../firebase/index";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
} from "react-bootstrap-table";
import { FormGroup } from "semantic-ui-react";
import {
  Button,
  Modal,
  ControlLabel,
  FormControl,
  Checkbox,
} from "react-bootstrap";
import _ from "lodash";
import Switch from "react-switch";
import { IoMdOptions } from "react-icons/io";

// Css
import "../../assets/css/grantaccesstables.css";
import "../../assets/css/header.css";
import "../../assets/css/mapview.css";
import "../../assets/css/maincss.css";

import LocalizedStrings from "react-localization";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    recipientNameHeader: "Recipient Name",
    recipientEmailHeader: "Recipient Email",
    selectRecipientBtn: "Lock Filter Options",
    editRecipientBtn: "Edit Recipient",
    popUpTitle: "Lock Filter Options",
    selectRecipientsLabel: "Disable Lock Options",
    selectRecipients2Label: "Filter Lock Options",
    selectRecipients4Label: "Lock Model",
    selectRecipients5Label: "Shared Locks",
    nameHeader: "Name",
    emailHeader: "Email",
    recipientListLabel: "Recipient List",
    okBtn: "OK",
    cancelBtn: "Cancel",
    noDataTitle: "There is no data to display",
    sharingMode2Title: "Toggle To Filter",
    online2Warning: "Only Non-Shared Locks Will Be Selectable",
    offline2Warning: "All Locks Are Selectable",
    checkboxText2: "FN721017",
    checkboxText3: "FN721019",
    checkboxText4: "A16570",
    checkboxText5: "IP66 Padlock",
    checkboxText6: "IP45 Padlock",
  },
  ja: {
    recipientNameHeader: "メンバー名",
    recipientEmailHeader: "メンバーEmail",
    selectRecipientBtn: "メンバー選択",
    editRecipientBtn: "メンバー編集",
    popUpTitle: "メンバー",
    selectRecipientsLabel: "メンバー選択",
    selectRecipients2Label: "ロックオプションをフィルターする",
    selectRecipients4Label: "ロックモデル",
    selectRecipients5Label: "共有ロック",
    nameHeader: "名前",
    emailHeader: "Eメール",
    recipientListLabel: "メンバーリスト",
    okBtn: "OK",
    cancelBtn: "キャンセル",
    noDataTitle: "表示するデータがありません。",
    sharingMode2Title: "フィルター用に切り替え",
    online2Warning: "非共有ロックのみが選択可能です",
    offline2Warning: "すべてのロックが選択可能です",
    checkboxText2: "FN721017",
    checkboxText3: "FN721019",
    checkboxText4: "A16570",
    checkboxText5: "IP66パドロック",
    checkboxText6: "IP45パドロック",
  },
  es: {
    recipientNameHeader: "Nombre del Destinatario",
    recipientEmailHeader: "Correo Electrónico del Destinatario",
    selectRecipientBtn: "Opciones de Filtro de Candado",
    editRecipientBtn: "Editar Destinatario",
    popUpTitle: "Opciones de Filtro de Candado",
    selectRecipientsLabel: "Deshabilitar Opciones de Candado",
    selectRecipients2Label: "Filtrar Opciones de Candado",
    selectRecipients4Label: "Modelo de Candado",
    selectRecipients5Label: "Candados Compartidas",
    nameHeader: "Nombre",
    emailHeader: "Correo Electrónico",
    recipientListLabel: "Lista de Destinatarios",
    okBtn: "Aceptar",
    cancelBtn: "Cancelar",
    noDataTitle: "No hay datos para mostrar",
    sharingMode2Title: "Alternar para Filtrar",
    online2Warning: "Solo se podrán seleccionar candados no compartidas",
    offline2Warning: "Todas las candados son seleccionables",
    checkboxText2: "FN721017",
    checkboxText3: "FN721019",
    checkboxText4: "A16570",
    checkboxText5: "Candado IP66",
    checkboxText6: "Candado IP45",
  },
});

class FilterOption extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showPopup: false,
      isDisabledSwitch: false,
      checkboxChecked5: false,
      checkboxChecked6: false,
    };

    this.handleInsertButtonClick = this.handleInsertButtonClick.bind(this);
    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.handleCheck5 = this.handleCheck5.bind(this);
    this.handleCheck6 = this.handleCheck6.bind(this);
  }

  componentWillMount() {
    //! LANGUAGE SETTING
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
  }

  handleInsertButtonClick() {
    this.setState({
      showPopup: true,
    });
  }

  handleCheck5(event) {
    const updatedValue = event.target.checked;
    this.setState({ checkboxChecked5: updatedValue });
    this.props.onCheckboxChange4(updatedValue);
  }

  handleCheck6(event) {
    const updatedValue = event.target.checked;
    this.setState({ checkboxChecked6: updatedValue });
    this.props.onCheckboxChange5(updatedValue);
  }

  handlePopupClose() {
    this.setState({
      showPopup: false,
    });
  }

  handleSwitchChange = () => {
    const { onSwitchChange } = this.props;
    const updatedSwitchValue = !this.state.isDisabledSwitch;
    this.setState({ isDisabledSwitch: updatedSwitchValue });
    onSwitchChange(!updatedSwitchValue); // Pass the opposite value to onSwitchChange function
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    return (
      <div>
        <button
          className="selectRecipientBtn2"
          onClick={() => this.handleInsertButtonClick()}
        >
          <IoMdOptions style={{ fontSize: "25px", marginTop: "1px" }} />
        </button>
        {/* //! Popup for Select Recipient Button */}
        <Modal
          show={this.state.showPopup}
          onHide={this.handlePopupClose}
          dialogClassName="modal-70w"
        >
          <Modal.Header closeButton>
            <Modal.Title>{localizationStrings.popUpTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "30px 30px 40px 30px" }}>
            <div className="selectMembersTable">
              <div style={{ fontSize: "1.7em" }}>
                {localizationStrings.selectRecipients4Label}
              </div>
              <br />
              <div
                className={"dropDownInput"}
                style={{
                  padding: "",
                  // width: "400px"
                }}
              >
                <Checkbox
                  inline
                  checked={this.state.checkboxChecked5}
                  onChange={this.handleCheck5}
                  style={{
                    color: "grey",
                    fontSize: "1.2em",
                    fontWeight: "bold",
                    marginTop: "0.1em",
                    marginLeft: "0.1em",
                    marginBottom: "0.5em",
                  }}
                >
                  <span style={{ marginRight: "10px" }}></span>
                  {localizationStrings.checkboxText5}
                </Checkbox>
              </div>
              <div
                className={"dropDownInput"}
                style={{
                  padding: "",
                  // width: "400px"
                }}
              >
                <Checkbox
                  inline
                  checked={this.state.checkboxChecked6}
                  onChange={this.handleCheck6}
                  style={{
                    color: "grey",
                    fontSize: "1.2em",
                    fontWeight: "bold",
                    marginTop: "0.1em",
                    marginLeft: "0.1em",
                    marginBottom: "0.5em",
                  }}
                >
                  <span style={{ marginRight: "10px" }}></span>
                  {localizationStrings.checkboxText6}
                </Checkbox>
              </div>
            </div>
            <br />
            <div style={{ fontSize: "1.7em" }}>
              {localizationStrings.selectRecipients5Label}
            </div>
            <br />
            <div className="grantSwitchInput" style={{ textAlign: "start" }}>
              <div style={{}}>
                <div style={{ display: "flex", marginBottom: "10px" }}>
                  <Switch
                    checked={this.state.isDisabledSwitch}
                    onChange={this.handleSwitchChange}
                    id="switch"
                  />
                  <div style={{ width: "15px" }} />
                  <label
                    htmlFor="normal-switch"
                    style={{
                      width: "250px",
                      fontSize: "15px",
                      color: "grey",
                      marginTop: "4.5px",
                    }}
                  >
                    {localizationStrings.sharingMode2Title}
                  </label>
                </div>
                <div style={{ display: "flex", width: "100%" }}>
                  <span style={{ width: "100%" }}>
                    {/* If TimedAccess switch is true (Ticked) */}
                    {this.state.isDisabledSwitch ? (
                      <p className={"switchInfo"} style={{ color: "red" }}>
                        {localizationStrings.online2Warning}
                      </p>
                    ) : (
                      // If TimedAccess switch is false
                      <p className={"switchInfo"} style={{ color: "grey" }}>
                        {localizationStrings.offline2Warning}
                      </p>
                    )}
                  </span>
                </div>
                <br />
              </div>
            </div>
            <FormGroup style={{ display: "flex" }}>
              <Button
                style={{ marginRight: "10px", marginBottom: "-10px" }}
                onClick={this.handlePopupClose}
              >
                {localizationStrings.okBtn}
              </Button>
            </FormGroup>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default FilterOption;
